import React from 'react'

import './_list.scss'

import cn from '../../libs/class-names'
import {mapChildrenWithFragments} from '../../services/react-children'

import {CommonProps, Overwrite} from '../../types'

import ListItem from './list-item'

type Props = Overwrite<
  CommonProps<'ul'>,
  {
    children: React.ReactNode
    size?: 'default' | 's'
    space?: 'default' | 's'
    checked?: boolean
    minor?: boolean
  }
>

const List = ({
  className,
  children,
  size = 'default',
  space = 'default',
  minor = false,
  checked = false,
  ...props
}: Props) => (
  <ul
    {...props}
    className={cn(
      'List',
      {[`size-${size}`]: !!size, [`space-${space}`]: !!space, minor, checked},
      className
    )}
  >
    {mapChildrenWithFragments<React.ComponentProps<typeof ListItem>>(children, child =>
      React.cloneElement(child, {checked})
    )}
  </ul>
)

export default List
